import { Component, Input } from '@angular/core';
import { GridCell } from 'ngrx-data-grid';

@Component({
  templateUrl: './carry-forward-column.component.html'
})
export class CarryForwardColumnComponent implements GridCell<boolean> {
  @Input() data: boolean;

}
